import { cn } from '@commenda/utils';
import React from 'react';

type FieldWrapperProps = {
  id: string;
  label: string;
  as?: 'span' | 'label';
  children: React.ReactNode;
  _css?: string;
  labelCss?: string;
};

const FieldWrapper = ({
  label,
  as = 'label',
  id,
  children,
  _css = '',
  labelCss = '',
}: FieldWrapperProps) => {
  const Component = as;

  return (
    <div className={cn('w-full flex flex-col gap-1', _css)}>
      <Component
        className={cn('text-md font-medium text-gray-900', labelCss)}
        htmlFor={id}
      >
        {label}
      </Component>
      {children}
    </div>
  );
};

export default FieldWrapper;
